import APIService from 'services/APIService'
import { GetCategoryImagesPayload } from 'types/onboarding'

const api = APIService()

export const fetchCategories = () => api.get('/onboarding-categories')

export const fetchCategoryImages = (payload: GetCategoryImagesPayload) =>
  api.get(`/onboarding-images/category/${payload.categoryId}`)
